  function stripHtmlTags(str: string) {
    return str.replace(/<[^>]*>/g, '');
  }
  interface IJsonLdFaq {
    question: string
    answer: string
  }
  export function JsonLdFaqString(faqItems: IJsonLdFaq[]) {
    const faqsConverted = faqItems.map((faq) => {
      return {
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: stripHtmlTags(faq.answer),
        },
      }
    })
    const content = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqsConverted,
    }
    return JSON.stringify(content)
  }
  interface JsonLdCourseProps {
    name: string
    url: string
    headline: string
    description: string
    audience: string
    text: string
    timeRequired?: string
    image?: string[]
    price: string
    paymentPlanPrice: string
  }

  export function JsonLdCourse({name, url, headline, description, audience, text, timeRequired, image, price, paymentPlanPrice}: JsonLdCourseProps){
    return {
      "@context": "https://schema.org",
      "@type": "Course",
      name,
      url,
      headline,
      description,
      provider: {
        "@type": "Organization",
          "name": "Every Tuesday",
          "sameAs": "https//every-tuesday.com"
      },
      audience: {
        "@type": "Audience",
        name: audience
      },
      author: [{ "@type": "Person", "name": "Teela Bigum", "url": "https://every-tuesday.com" }],
      text,
      timeRequired,
      image,
      hasCourseInstance: [
        {
          "@type": "CourseInstance",
          courseMode: [
            "Self Paced",
            "One Time Payment",
            "Online"
          ],
          offers: {
            "@type": "Offer",
            price,
            priceCurrency: "USD"
          }
        },
        {
          "@type": "CourseInstance",
          courseMode: [
            "Self Paced",
            "3 Monthly Payments",
            "Online"
          ],
          offers: {
            "@type": "Offer",
            price: paymentPlanPrice,
            priceCurrency: "USD"
          }
        }
      ],
      potentialAction: {
        "@type": "BuyAction",
        price,
        priceCurrency: "USD",
        target: url,
        result: "Enrolled in course",
        agent: {
          "@type": "Person",
            name: "Teela"
        },
        object: {
          "@type": "Course",
          name,
          description,
          provider: {
            "@type": "Organization",
            name: "Every Tuesday",
            sameAs: "https//every-tuesday.com"
          }
        },
        seller: {
          "@type": "Organization",
          name: "Every Tuesday",
          sameAs: "https//every-tuesday.com"
        }
      }
    }
  }